/**
 * ES6 overflow menu dropdown functionality
 */
class OverflowMenu {
  /**
   * @param {HTMLButtonElement} button
   */
  constructor(button) {
    this.button = button;
    this.dropdown = button.nextElementSibling instanceof HTMLElement ? button.nextElementSibling : null;

    this.toggle = this.toggle.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.init();
  }

  init() {
    this.button.addEventListener("click", this.toggle);
    document.addEventListener("click", this.handleOutsideClick);
  }

  /**
   * Toggle dropdown visibility
   * @param {MouseEvent} e
   */
  toggle(e) {
    e.stopPropagation();
    if (!this.dropdown) return;

    const isHidden = this.dropdown.hidden;
    this.dropdown.hidden = !isHidden;
    this.button.setAttribute("aria-expanded", String(isHidden));
  }

  /**
   * Close dropdown when clicking outside
   * @param {MouseEvent} e
   */
  handleOutsideClick(e) {
    const target = e.target instanceof Node ? e.target : null;
    if (!target || !this.button.parentElement || !this.dropdown) return;

    if (!this.button.parentElement.contains(target)) {
      this.dropdown.hidden = true;
      this.button.setAttribute("aria-expanded", "false");
    }
  }

  destroy() {
    this.button.removeEventListener("click", this.toggle);
    document.removeEventListener("click", this.handleOutsideClick);
  }
}

/**
 * Initialize all overflow menus on the page
 */
const initOverflowMenus = () => {
  document.querySelectorAll(".overflow-menu-btn").forEach((button) => {
    if (button instanceof HTMLButtonElement) {
      new OverflowMenu(button);
    }
  });
};

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOverflowMenus);
} else {
  initOverflowMenus();
}
